




















import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import config, { setConfig } from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageFeaturesFlags",
  components: {
    BaseInput,
    BaseIconButton,
    PageTitle,
    BaseButton,
    BaseCheckbox,
    BasePage,
  },
  setup(_, { root }) {
    const filterText = ref("");
    const features = ref<Record<string, boolean>>(
      Object.entries(config)
        .filter(([key, value]) => /(temp)?feature/i.test(key) && typeof value === "boolean")
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
    );

    const featuresToView = computed(() => {
      let result = Object.keys(features.value);
      if (filterText.value) {
        const regExp = new RegExp(filterText.value, "i");
        result = result.filter(key => regExp.test(key));
      }
      return result.sort();
    });

    const changedFeatures = ref<Record<string, boolean>>({});

    const changeFeatures = (key: string) => {
      features.value[key] = !features.value[key];
      changedFeatures.value[key] = features.value[key];
    };

    const saveFeatures = () => {
      localStorage.setItem("features", JSON.stringify(changedFeatures.value));
      setConfig(changedFeatures.value);
      root.$router.push({ name: "more" });
    };

    const resetFeatures = () => {
      localStorage.removeItem("features");
      location.reload();
    };

    onMounted(() => {
      const features = localStorage.getItem("features");
      if (features) {
        changedFeatures.value = JSON.parse(features);
      }
    });

    return {
      features,
      featuresToView,
      filterText,
      saveFeatures,
      resetFeatures,
      changeFeatures,
    };
  },
});
